// todo:
// git push
// - deploy

import React, { Component } from 'react';
import PaperReferencer from '../../components/PaperReferencer/PaperReferencer';
import ReferencesModal from '../../components/ReferencesModal/ReferencesModal';
import Strings from 'localization/Strings';
import './Result.css';
import { Stack } from 'react-bootstrap';
import MyButton from '../../components/MyButton/MyButton';
import SimplePie from '../../components/SimplePie/SimplePie';
import {GoInfo} from 'react-icons/go'
import Histogram from '../../components/Histogram/Histogram';
import Modal from 'react-bootstrap/Modal';
import { MdRectangle } from 'react-icons/md';

class Result extends Component {
    state = {
        showWordScoreGraphInfoModal: false,
        showClarityGraphInfoModal: false,
        showSmallCardInfoModal: false,
        showSmallCardInfoCat: "",
        showSmallCardInfoScore: -1,
        showReferencesModal: false,
    };    
    constructor(props){
        super(props);
        this.onRestart = props.onRestart;
        this.onSubmit = props.onSubmit;

        this.statModel = props.statModel;
        this.StatModelMoreInfo = this.props?.StatModelMoreInfo;
        this.isBriefMode = props.isBriefMode || false;
    }
    modalsClose(){
        this.setState({showWordScoreGraphInfoModal: false, 
                        showClarityGraphInfoModal: false,
                        showSmallCardInfoModal: false,
                        showReferencesModal: false});
    }
    showReferencesModal(){
        this.setState({
            showWordScoreGraphInfoModal: false, 
            showClarityGraphInfoModal: false,
            showSmallCardInfoModal: false,
            showReferencesModal: true
        });
    }
    showWordScoreGraphInfoModal(){
        this.setState({showWordScoreGraphInfoModal: true, 
            showClarityGraphInfoModal: false,
            showSmallCardInfoModal: false,
        });
    }
    showClarityGraphInfoModal(){
        this.setState({showWordScoreGraphInfoModal: false, 
            showClarityGraphInfoModal: true,
            showSmallCardInfoModal: false,
        });
    }
    showSmallCardInfoModal(cat, score){
        this.setState({showWordScoreGraphInfoModal: false, 
            showClarityGraphInfoModal: false,
            showSmallCardInfoModal: true,
            showSmallCardInfoCat: cat,
            showSmallCardInfoScore: score,});
    }

    render () { 
        const unclearString = '   ' + Strings.strings.Results.Unclear; // adding spaces to align with histogram label, spacing is not supported.
        const clearAndNaturalString = Strings.strings.Results.ClearAndNatural + '                  '; // adding spaces to align with histogram label, spacing is not supported.

        const OoO = Math.round(this.statModel.Ssq.OoO);
        const phone = Math.round(this.statModel.Ssq.phone);
        const effort = Math.round(this.statModel.Ssq.effort);

        const bins = this.statModel.wordScore.paddedValues;
        const data = this.statModel.wordScore.normalizedPaddedProbabilities;
        const current = this.statModel.wordScore.preop;

        const ssqBins = this.statModel.Ssq.clarities.values;
        const ssqData = this.statModel.Ssq.clarities.normalizedProbabilities;
        const ssqCurrent = this.statModel.inputModel.user_selection_ssq_clarity;

        return (
            <div className='' id='result-container'>
                <Modal show={this.state.showWordScoreGraphInfoModal} onHide={() => this.modalsClose()}
                    aria-labelledby="contained-modal-title-vcenter"
                    size='sm'
                    centered> 
                    <Modal.Body className='body1'>
                        <div className='row'> 
                            <div className='col text-left ms-1'>
                                <GoInfo className='info-icon' onClick={() => this.showWordScoreGraphInfoModal()} />
                            </div>
                            <span onClick={() => this.modalsClose()} className='col text-right pointer'>
                                ✕
                            </span>
                        </div>
                        <div className='mt-3'>
                            <div className='row ms-1'> 
                                <div className='col-1 legend-rect green110-bg'></div>
                                <span className='col' dangerouslySetInnerHTML={{__html: Strings.strings.addParams(Strings.strings.Results.LegendWordScoreYou, Math.round(current))}} />
                            </div>
                        </div>
                        <div className='mt-2'>
                            <div className='row ms-1'> 
                                <div className='col-1 legend-rect lavender120-bg'></div>
                                <span className='col' dangerouslySetInnerHTML={{__html: Strings.strings.addParams(Strings.strings.Results.LegendWordScoreAfter, this.statModel.wordScore.chance, this.statModel.wordScore.chanceRange[0],this.statModel.wordScore.chanceRange[1])}} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.showClarityGraphInfoModal} onHide={() => this.modalsClose()}
                    aria-labelledby="contained-modal-title-vcenter"
                    size='sm'
                    centered> 
                    <Modal.Body className='body1'>
                        <div className='row'> 
                            <div className='col text-left ms-1'>
                                <GoInfo className='info-icon' onClick={() => this.showClarityGraphInfoModal()} />
                            </div>
                            <span onClick={() => this.modalsClose()} className='col text-right pointer'>
                                ✕
                            </span>
                        </div>
                        <div className='mt-3'>
                            <div className='row ms-1'> 
                                <div className='col-1 legend-rect green110-bg'></div>
                                <span className='col' dangerouslySetInnerHTML={{__html: Strings.strings.addParams(Strings.strings.Results.LegendSsqClarityYou, ssqCurrent)}} />
                            </div>
                        </div>
                        <div className='mt-2'>
                            <div className='row ms-1'> 
                                <div className='col-1 legend-rect lavender120-bg'></div>
                                <span className='col' dangerouslySetInnerHTML={{__html: Strings.strings.Results.LegendSsqClarityAfter}} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.showSmallCardInfoModal} onHide={() => this.modalsClose()}
                    aria-labelledby="contained-modal-title-vcenter"
                    size='sm'
                    centered> 
                    <Modal.Body className='body1'>
                        <div className='row'> 
                            <div className='col text-left ms-1'>
                                <GoInfo className='info-icon'/>
                            </div>
                            <span onClick={() => this.modalsClose()} className='col text-right pointer'>
                                ✕
                            </span>
                        </div>
                        <div className='mt-3'>
                            <div className='row ms-1'> 
                                <div className='col-1 legend-rect green110-bg'></div>
                                <span className='col' > {Strings.strings.addParams(Strings.strings.Results.InfoSmallCardsGreen, this.state.showSmallCardInfoCat, this.state.showSmallCardInfoScore)}</span>
                            </div>
                        </div>
                        <div className='mt-2'>
                            <div className='row ms-1'> 
                                <div className='col-1 legend-rect lavender120-bg'></div>
                                <span className='col' > {Strings.strings.Results.InfoSmallCardsPurple}</span>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>                                    
                <div id='panels' className='row g-0'>
                    <div id='left-panel' className='col-9 card-column'>
                        <div className='card-container card-container-left'> 
                            <Stack>
                                <div className='white-card'>
                                    <div className='row g-0 mb-4'>
                                        <div className='sub-heading2 col-9'>
                                            <span className=''>{Strings.strings.Results.SpeechTestTitle}</span>
                                            <span className='text-right caption1'><PaperReferencer refIndex={[5]} className=" col smoke100 p0-impose" onClick={() => this.showReferencesModal()} /></span>
                                            <span className='ms-2 smoke120 caption1'>{Strings.strings.Results.SpeechTestDescription}</span>
                                        </div>
                                        <div className='col-3 text-right'>
                                            <GoInfo className='info-icon pointer' onClick={() => this.showWordScoreGraphInfoModal()} />
                                        </div>
                                    </div>
                                    <div className='row g-0'>
                                        <div className='col-6'>
                                            <Histogram labels={bins} 
                                                data={data}
                                                current={current} 
                                                className="hist"
                                                xTicks={[0,50,100]}
                                                xTickLabels={[' 0%','50%','100%      ']}
                                                />
                                        </div>
                                        <div className='col-4 ms-5 mb-5'>  
                                            <span dangerouslySetInnerHTML={{__html: Strings.strings.addParams(Strings.strings.Results.SpeechTestBody, this.statModel.wordScore.chance)}}></span>
                                        </div>
                                    </div>
                                </div>
                                <div className='white-card'>
                                    <div className='row g-0 mb-4'>
                                        <div className='sub-heading2 col-9'>
                                            <span className=''>{Strings.strings.Results.ClarityTitle}</span>
                                            <span className='text-right caption1'><PaperReferencer refIndex={[6]} className=" col smoke100 p0-impose" onClick={() => this.showReferencesModal()} /></span>
                                        </div>
                                        <div className='col-3 text-right'>
                                            <GoInfo className='info-icon pointer' onClick={() => this.showClarityGraphInfoModal()} />
                                        </div>
                                    </div> 
                                    <div className='row g-0'>
                                        <div className='col-6'>
                                            <Histogram labels={ssqBins} 
                                                    data={ssqData}
                                                    current={ssqCurrent} 
                                                    className="hist"
                                                    xTicks={[0,10]}
                                                    xTickLabels={[unclearString,clearAndNaturalString]}
                                                    />
                                        </div>
                                        <div className='col-4 ms-5'>  
                                            <span dangerouslySetInnerHTML={{__html: Strings.strings.Results.ClarityBody}}></span>
                                        </div>
                                    </div>
                                </div>                                
                            </Stack>
                        </div>
                    </div>
                    <div id='right-panel' className='col-3 card-column'>
                        <div className='card-container card-container-right'>
                            <Stack>
                                {/* OoO conversation card */}
                                <div className='white-card'>
                                    <div className='row g-0 mb-4'>
                                        <div className='sub-heading2 col'>{Strings.strings.Results.OoOTitle}</div>
                                        <div className='col text-right'>
                                            <PaperReferencer refIndex={[6, 16, 17, 19]} className=" col smoke100 p0-impose" onClick={() => this.showReferencesModal()} />
                                            <GoInfo className='info-icon mini-info' onClick={() => this.showSmallCardInfoModal(Strings.strings.Results.OneOnOneConversation, this.statModel.inputModel.user_selection_ssq_OoO)} />
                                        </div>
                                    </div>
                                    <div className='row g-0 mb-4'>
                                        <div className='sub-heading2 col-4'>
                                            <SimplePie percent={OoO} />
                                        </div>
                                        <div className='col-8 text-right tight-line-height'>
                                            <span dangerouslySetInnerHTML={{__html: Strings.strings.addParams(Strings.strings.Results.OoOBody, OoO)}}></span>
                                        </div>
                                    </div>                                     
                                </div>
                                {/* Phone card */}
                                <div className='white-card'>
                                    <div className='row g-0 mb-4'>
                                        <div className='sub-heading2 col-8'>{Strings.strings.Results.PhoneTitle}</div>
                                        <div className='col text-right'>
                                            <PaperReferencer refIndex={[6, 14,16,17]} className=" col smoke100 p0-impose" onClick={() => this.showReferencesModal()} />
                                            <GoInfo className='info-icon mini-info' onClick={() => this.showSmallCardInfoModal(Strings.strings.Results.Phone, this.statModel.inputModel.user_selection_ssq_telephone)} />
                                        </div>
                                    </div>
                                    <div className='row g-0 mb-4'>
                                        <div className='sub-heading2 col-4'>
                                            <SimplePie percent={phone} />
                                        </div>
                                        <div className='col-8 text-right tight-line-height'>
                                            <span dangerouslySetInnerHTML={{__html: Strings.strings.addParams(Strings.strings.Results.PhoneBody, phone)}}></span>
                                        </div> 
                                    </div>                                    
                                </div>  
                                {/* each of hearing card */}
                                <div className='white-card'>
                                    <div className='row g-0 mb-4'>
                                        <div className='sub-heading2 col-8'>{Strings.strings.Results.EaseTitle}</div>
                                        <div className='col text-right'>
                                            <PaperReferencer refIndex={[6]} className=" col smoke100 p0-impose" onClick={() => this.showReferencesModal()} />
                                            <GoInfo className='info-icon mini-info' onClick={() => this.showSmallCardInfoModal(Strings.strings.Results.EffortOfHearing, this.statModel.inputModel.user_selection_ssq_effort)} />
                                        </div>
                                    </div>
                                    <div className='row g-0 mb-4'>
                                        <div className='sub-heading2 col-4'>
                                            <SimplePie percent={effort} /> 
                                        </div>
                                        <div className='col-8 text-right tight-line-height'>
                                            <span dangerouslySetInnerHTML={{__html: Strings.strings.addParams(Strings.strings.Results.EaseBody, effort)}}></span>
                                        </div>
                                    </div>                                    
                                </div>  
                                <div className='result-next-button-container p-4'>
                                    <MyButton type="white" className="w100p align-middle result-next-button" onClick={() => this.onSubmit()} text={Strings.strings.General.Next} />
                                </div>
                            </Stack>
                        </div>
                    </div>
                </div>
                <ReferencesModal 
                    show={this.state.showReferencesModal} 
                    onHide={() => this.modalsClose()} 
                />
            </div>
        );
    }
}

export default Result;